import { ImageIcon } from 'lucide-react';
import type { PreviewMediaAsset } from './previewContent';

export function MediaPlaceholder({ asset, priority = false }: { asset: PreviewMediaAsset; priority?: boolean }) {
  if (asset.src) {
    return <img className="preview-media__image" src={asset.src} alt={asset.alt} loading={priority ? 'eager' : 'lazy'} width="1440" height="1000" />;
  }
  return (
    <figure className="preview-media" role="img" aria-label={`${asset.label}. Placeholder for ${asset.alt}.`}>
      <ImageIcon aria-hidden="true" />
      <figcaption>
        <strong>{asset.label}</strong>
        <span>{asset.recommendedSize}</span>
        <code>{asset.key}</code>
      </figcaption>
    </figure>
  );
}
